// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cinccino: PokeData = {
  "id": 573,
  "name": "cinccino",
  "height": 5,
  "weight": 75,
  "base_experience": 165,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "slam",
    "sing",
    "swift",
    "charm",
    "encore",
    "helping-hand",
    "hyper-voice",
    "tickle",
    "bullet-seed",
    "rock-blast",
    "last-resort",
    "after-you",
    "echoed-voice",
    "tail-slap",
    "baby-doll-eyes"
  ],
  "moves": [
    "hyper-voice",
    "bullet-seed",
    "rock-blast",
    "growl",
    "scratch",
    "leer",
    "supersonic",
    "protect",
    "purification",
    "scary-face",
    "headbutt",
    "body-slam",
    "tri-attack"
  ],
  "evolution_chain": {
    "id": 292,
    "item": null,
    "species": [
      {
        "name": "minccino",
        "order": 573,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cinccino",
        "order": 574,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 572,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "shiny-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 97,
    "speed": 166,
    "ability_power": 137
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
